// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7d20b25e","780":"cb6975a8"}[chunkId] + ".chunk.js";
};